﻿import React from 'react';
import Diagram, { CustomShape, Nodes, Edges, AutoLayout, Toolbox, Group } from 'devextreme-react/diagram';

import 'devexpress-diagram/dist/dx-diagram.min.css';

const tasks = [
    {
        id: 1,
        title: 'Start',
        status: 'Complete',
        signOff: 'Andy Ommen'
    }, {
        id: 2,
        pid: 1,
        title: 'Product Planning',
        status: 'Complete',
        signOff: 'Andy Ommen'
    },{
        id: 33,
        pid: 2,
        title: 'Notification',
        status: 'Complete',
        signOff: 'Phil Laue'
    }, {
        id: 3,
        pid: 2,
        title: 'BOM Creation',
        status: 'In Process',
        signOff: 'Phil Laue'
    }, {
        id: 4,
        pid: 3,
        title: 'RM Schedule',
        status: 'Not Started',
        signOff: ''
    }, {
        id: 5,
        pid: 3,
        title: 'Historical Analysis',
        status: 'Not Started',
        signOff: ''
    }, {
    id: 6,
        pid: 3,
         title: 'HR Allocation',
         status: 'Not Started',
         signOff: ''
    }, {
        id: 7,
        pid: 3,
        title: 'Machine Allocation',
        status: 'Not Started',
        signOff: ''
    }
];


const flowEdges = [
    {
        fromId: 1,
        id: 100,
        text: null,
        toId: 2,
    },
    {
        fromId: 2,
        id: 101,
        text: null,
        toId: 3,
    },
    {
        fromId: 2,
        id: 102,
        text: null,
        toId: 33,
    },
    {
        fromId: 3,
        id: 103,
        text: null,
        toId: 4,
    },
    {
        fromId: 3,
        id: 104,
        text: null,
        toId: 5,
    },
    {
        fromId: 3,
        id: 105,
        text: null,
        toId: 6,
    },    
    {
        fromId: 3,
        id: 106,
        text: null,
        toId: 7,
    }



];


export default function DmaDiagram() {

    function itemTypeExpr(obj: { id: number; }) {
        return `task${obj.id}`;
    }

    return (

        <div>
            <Diagram id="diagram" 
                height="90vh" 
                onItemClick={onDiagramItemClick}
                onOptionChanged={onDiagramOptionChanged}
                onRequestEditOperation={onDiagramRequestEditOperation}
                onRequestLayoutUpdate={onDiagramRequestLayoutUpdate}
                onSelectionChanged={onDiagramSelectionChanged}
                customShapeRender={customShapeTemplate}>
                {tasks.map((t, idx) => <CustomShape
                    type={`task${t.id}`}
                    baseType="rectangle"
                    defaultWidth={1.5}
                    defaultHeight={1}
                    allowEditText={false}
                    allowResize={false}
                    key={idx} />)}

                <Nodes dataSource={tasks} keyExpr="id" typeExpr={itemTypeExpr} >
                    <AutoLayout type="layered" />
                </Nodes>
                {/* Used with AutoLayout type "tree": parentKeyExpr="pid"  
                <AutoLayout type="tree" />    
                */}


                <Edges dataSource={flowEdges} textExpr="text" fromExpr="fromId" toExpr="toId" />
               
            </Diagram>
        </div>
    );


    function onDiagramItemClick(e:any) {
        console.log("onDiagramItemClick");
        console.log(e);
    }

    function onDiagramOptionChanged(e: any) {
        console.log("onDiagramOptionChanged");
        console.log(e);
    }

    function onDiagramRequestEditOperation(e: any) {
       // console.log("onDiagramRequestEditOperation");
       // console.log(e);
    }

    function onDiagramRequestLayoutUpdate(e: any) {
        console.log("onDiagramRequestLayoutUpdate");
        console.log(e);


        if (e.changes && e.changes.length > 0) {
            console.log("AT 172");

            let newShape = e.changes[0];

            if (newShape.type === "insert") {

                console.log("AT 178");

                newShape.data.title = "NEW";
                newShape.text = "New Text";

            }


        }
    }

    function onDiagramSelectionChanged(e: any) {
        console.log("onDiagramSelectionChanged");
        console.log(e);
    }


    function customShapeTemplate(task) {
        console.log(task);

        const t = task.dataItem;

        let statusFill = "diagram-header-fill-default";

        if (t.title === "Notification")
            statusFill = "diagram-header-fill-red";
        else {
            if (t.status === "Complete")
                statusFill = "diagram-header-fill-green";
            else if (t.status === "In Process")
                statusFill = "diagram-header-fill-orange";
        }

        const headerCss = `diagram-style1 ${statusFill}`;

        return (
            <svg>
                <rect width="100%" height="15" x="0" y="0" className={headerCss} />
                <rect width="100%" height="90" x="0" y="15" className="diagram-style2" />

                <text width="100%" x="50%" y="35" fill="#333" className="diagram-style3">{t.title}</text>
                <text width="100%" x="50%" y="55" fill="#333" className="diagram-style4">{t.status}</text>
                <text width="100%" x="50%" y="75" fill="#333" className="diagram-style5">{t.signOff}</text>
            </svg>
        );

        /*
        
            <svg className="template">
                <text className="template-name" x="50%" y="20%">{employee.Title}</text>
                <text className="template-title" x="50%" y="45%">{employee.Title}</text>
            </svg>
            */
    }


}
